var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MultipleChoicesDropdown',{attrs:{"title":_vm.title,"value":_vm.value,"show-clear-all":false,"single-choice":_vm.singleChoice,"search-enabled":true,"choices":_vm.choices},on:{"change":function($event){return _vm.onChange($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }